import { render, staticRenderFns } from "./ImportInstanceDetailsModal.vue?vue&type=template&id=12a05aaa&scoped=true"
import script from "./ImportInstanceDetailsModal.vue?vue&type=script&lang=js"
export * from "./ImportInstanceDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./ImportInstanceDetailsModal.vue?vue&type=style&index=0&id=12a05aaa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a05aaa",
  null
  
)

export default component.exports